"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertor = exports.taskFromOperationNode = void 0;
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const uiNodes_1 = require("../../uiNodes");
const types_1 = require("./types");
const taskToOperationNode = (task) => {
    const { srcArtifactSlug: _unused2, ...nodeConfiguration } = task;
    const tapeBuilderNodeId = (0, uuid_1.v4)();
    const operationNode = {
        metadata: {
            tapeBuilderNodeId,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: nodeConfiguration,
    };
    return operationNode;
};
const taskFromOperationNode = ({ srcNodes, operationNode, }) => {
    const { configuration } = operationNode;
    (0, common_1.finleyAssert)(srcNodes.length >= 1, `ai2Csv node has [${srcNodes.length}] src nodes`);
    const artifactSlugs = srcNodes.map((srcNode) => {
        const uiNode = (0, uiNodes_1.getUINodeByType)(srcNode.metadata.tapeBuilderNodeType);
        (0, common_1.finleyAssert)(!uiNode.isOperation, 'source node can not be an operation node');
        return uiNode.getArtifactSlug(srcNode);
    });
    const srcArtifactSlug = artifactSlugs[0];
    return {
        srcArtifactSlug,
        ...configuration,
    };
};
exports.taskFromOperationNode = taskFromOperationNode;
exports.convertor = {
    operation: 'ai2Csv',
    nodeType: types_1.nodeType,
    taskToOperationNode,
    taskFromOperationNode: exports.taskFromOperationNode,
    toTransformation: (task, resolveDef) => {
        const { fields, srcArtifactSlug, baseFieldsTemplate, ...rest } = task;
        // if fields are explicitly specified, we don't need to input tape to have srcDataTape
        if (fields) {
            return {
                isValid: true,
                data: {
                    srcDataTape: null,
                    baseFieldsTemplate,
                    fields,
                    ...rest,
                },
            };
        }
        if (baseFieldsTemplate) {
            let baseFields;
            switch (baseFieldsTemplate) {
                case 'balanceSheet':
                case 'incomeStatement':
                    baseFields = tape_sanitizer_1.FINANCIAL_STATEMENT_BASE_FIELDS;
                    break;
                default:
                    throw (0, common_1.finleyAssertUnreachable)(baseFieldsTemplate);
            }
            return {
                isValid: true,
                data: {
                    srcDataTape: null,
                    baseFieldsTemplate,
                    fields: baseFields,
                    ...rest,
                },
            };
        }
        try {
            const srcDataTape = resolveDef(srcArtifactSlug);
            if (!srcDataTape.isValid) {
                return {
                    isValid: false,
                    errors: srcDataTape.errors,
                };
            }
            (0, common_1.finleyAssert)(srcDataTape.data, 'TapeDefinition is null for ai2Csv operation inputs');
            return {
                isValid: true,
                data: {
                    srcDataTape: srcDataTape.data,
                    baseFieldsTemplate,
                    ...rest,
                },
            };
        }
        catch (err) {
            // since ai2csv allows fields to be optionally configured,
            // it is not guaranteed we will find upstream tape with fields defined.
            // if we cannot a source tape with fields, we will get hit with an assert from typeguards.isTapeBuilderTask eventually
            // this error is difficult to debug, so we will gracefully handle with the minimal information in the err
            const message = (0, common_1.getErrorMessage)(err);
            if (message.startsWith('createTapeBuilder:tape configuration is not of task TapeBuilderTask')) {
                return {
                    isValid: false,
                    errors: [
                        'Unable to find source data tape with fields definition. You must specify fields on an upstream tape or the ai2Csv node.',
                    ],
                };
            }
            throw err;
        }
    },
};
//# sourceMappingURL=converter.js.map